import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';

import { PostUploadBudgets } from 'domain/usecases/budgets/upload-budgets';
import { RemotePostUploadBudgets } from 'data/usecases/budgets/remote-post-upload-budgets';

export const makeRemoteUploadBudget = (): PostUploadBudgets => {
  return new RemotePostUploadBudgets(makeApiUrl('/budgets/upload'), makeAuthorizeHttpClientDecorator());
};
